module.exports = __webpack_public_path__ + "img/HC1035-163.ca472b11.jpg";